import apiService from '../utils/apiService';

import {
  ADD_DECISION_TYPE_ATTACHMENT,
  ADD_DECISION_TYPE_ATTACHMENT_START,
  ADD_DECISION_TYPE_ATTACHMENT_ERROR,
  GET_DECISION_TYPE_ATTACHMENT,
  GET_DECISION_TYPE_ATTACHMENT_START,
  GET_DECISION_TYPE_ATTACHMENT_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_LIST,
  GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_LIST_START,
  GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE,
  REMOVE_ATTACHMENT,
  CLEAR_ERROR_DECISION_TYPE_ATTACHMENT,
} from './types';

import {
  decisionTypeAttachmentUploadPath,
  decisionTypeAttachmentFindByDecisionTypePath,
  decisionTypeAttachmentFindByDecisionTypeNamePath,
  decisionTypeAttachmentFindAllByDecisionTypeIdPath,
  decisionTypeAttachmentFindAllPageablePath,
  downloadDecisionTypeAttachmentPath,
} from '../constants/apiEndpoints';

const clearError = () => {
  return {
    type: CLEAR_ERROR_DECISION_TYPE_ATTACHMENT,
  };
};

const unmountAttachment = () => {
  return {
    type: REMOVE_ATTACHMENT,
  };
};

const addDecisionTypeAttachmentStart = () => {
  return {
    type: ADD_DECISION_TYPE_ATTACHMENT_START,
  };
};
const addDecisionTypeAttachmentSuccessfully = (data) => {
  return {
    type: ADD_DECISION_TYPE_ATTACHMENT,
    payload: data,
  };
};
const addDecisionTypeAttachmentUnsuccessfully = (err) => {
  return {
    type: ADD_DECISION_TYPE_ATTACHMENT_ERROR,
    payload: err,
  };
};

const getDecisionTypeAttachmentStart = () => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_START,
  };
};
const getDecisionTypeAttachmentSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT,
    payload: data,
  };
};
const getDecisionTypeAttachmentUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_ERROR,
    payload: err,
  };
};

const getDecisionTypeAttachmentContentForPreviewStart = () => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START,
  };
};
const getDecisionTypeAttachmentContentForPreviewSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW,
    payload: data,
  };
};
const getDecisionTypeAttachmentContentForPreviewUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR,
    payload: err,
  };
};

const getDecisionTypeAttachmentListStart = () => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_LIST_START,
  };
};
const getDecisionTypeAttachmentListSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_LIST,
    payload: data,
  };
};
const getDecisionTypeAttachmentListUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR,
    payload: err,
  };
};

const getDecisionTypeAttachmentPageableListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const downloadAttachmentSuccessfuly = (data, decisionTypeName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', decisionTypeName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
};

export const uploadDecisionTypeAttachment = (
  fileData,
  decisionId,
  callback
) => {
  return (dispatch) => {
    dispatch(addDecisionTypeAttachmentStart());
    return apiService
      .post(decisionTypeAttachmentUploadPath(decisionId), fileData)
      .then((response) => {
        dispatch(addDecisionTypeAttachmentSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addDecisionTypeAttachmentUnsuccessfully(err?.response?.data));
      });
  };
};

export const findDecisionTypeAttachment = (decisionId) => {
  return (dispatch) => {
    dispatch(getDecisionTypeAttachmentStart());
    return apiService
      .get(decisionTypeAttachmentFindByDecisionTypePath(decisionId))
      .then((response) => {
        dispatch(getDecisionTypeAttachmentSuccessfully(response.data));
        dispatch(
          findDecisionTypeAttachmentByDecisionTypeName(
            response && response.data && response.data.uuidDocName,
            'decisionTypeAttachment'
          )
        );
      })
      .catch((err) => {
        dispatch(getDecisionTypeAttachmentUnsuccessfully(err?.response?.data));
      });
  };
};

export const findDecisionTypeAttachmentByDecisionTypeName = (
  decisionTypeName,
  controllerReference
) => {
  return (dispatch) => {
    dispatch(getDecisionTypeAttachmentContentForPreviewStart());
    return apiService
      .get(
        decisionTypeAttachmentFindByDecisionTypeNamePath(
          decisionTypeName,
          controllerReference
        )
      )
      .then((response) => {
        dispatch(
          getDecisionTypeAttachmentContentForPreviewSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getDecisionTypeAttachmentContentForPreviewUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const removeAttachment = () => {
  return (dispatch) => {
    dispatch(unmountAttachment());
  };
};

export const deleteErrorDecisionTypeAttachment = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllDecisionTypeAttachmentsByDecisionId = (decisionId) => {
  return (dispatch) => {
    dispatch(getDecisionTypeAttachmentListStart());
    return apiService
      .get(decisionTypeAttachmentFindAllByDecisionTypeIdPath(decisionId))
      .then((response) => {
        dispatch(getDecisionTypeAttachmentListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getDecisionTypeAttachmentListUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findAllDecisionTypeAttachmentPageable = (
  decisionId,
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch(getDecisionTypeAttachmentListStart());
    return apiService
      .get(
        decisionTypeAttachmentFindAllPageablePath(
          decisionId,
          pageNumber,
          pageSize
        )
      )
      .then((response) => {
        dispatch(
          getDecisionTypeAttachmentPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getDecisionTypeAttachmentListUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const downloadAttachment =
  (uuidDocName, decisionTypeName) => async (dispatch) => {
    return apiService
      .getFromFile(downloadDecisionTypeAttachmentPath(uuidDocName))
      .then((response) => {
        dispatch(
          downloadAttachmentSuccessfuly(response.data, decisionTypeName)
        );
      })
      .catch((err) => {
        dispatch(getDecisionTypeAttachmentUnsuccessfully(err?.response?.data));
      });
  };
